import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { DeliveryMethodStatisticModel } from '../../../models/delivery-method-statistic-model';
import { StatisticsResource } from '../../../services/resources/statistics.resource';

@Component({
    selector: 'sl-delivery-methods-statistic',
    templateUrl: './delivery-methods-statistic.component.html',
    styleUrls: ['./delivery-methods-statistic.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeliveryMethodsStatisticComponent implements OnInit {
    languages: string[] = [];
    deliveryMethods: string[] = [];
    items: DeliveryMethodStatisticModel[] = [];
    locationPaperGroupStatistic: { label: string; total: number }[] = [];
    paperTotalLabel: string;
    paperTotal = 0;

    private readonly statisticsResource = inject(StatisticsResource);

    ngOnInit(): void {
        this.statisticsResource.getDeliveryMethods().subscribe(r => {
            this.items = r.value;

            this.setupLocationsData();
            this.setupLanguagesData();
        });
    }

    getData(language: string, deliveryMethod: string): number {
        let sum = 0;
        this.items
            .filter(i => i.language === language && i.deliveryMethod === deliveryMethod)
            .forEach(i => (sum += i.numberOfShareholders));

        return sum;
    }

    private setupLanguagesData(): void {
        this.languages = [...new Set(this.items.map(i => i.language))];
        this.deliveryMethods = [...new Set(this.items.map(i => i.deliveryMethod))];
    }

    private setupLocationsData(): void {
        const locations = [...new Set(this.items.filter(i => i.isPaper).map(i => i.location))];

        locations.forEach(i => {
            const filtered = this.items.filter(f => f.location === i && f.isPaper);
            const label = `${filtered[0].deliveryMethod} ${filtered[0].location}`;

            const total = filtered.reduce((currentTotal, item) => (currentTotal += item.numberOfShareholders), 0);

            this.locationPaperGroupStatistic.push({ label, total });

            this.paperTotalLabel = filtered[0].deliveryMethod;
            this.paperTotal += total;
        });
    }
}
